import { useState, useMemo, useEffect, useCallback } from 'react';

import WSClient from 'helpers/websocket';

const useWebSocket = (opts = {}) => {
  const [connected, setConnected] = useState(false);

  if (!opts.url) {
    throw new Error('No websocket url provided to useWebSocket');
  }

  const client = useMemo(() => {
    return new WSClient({
      url: opts.url,
      retries: opts.retries,
      retryTimeout: opts.retryTimeout,
    });
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [opts.url]);

  useEffect(() => {
    client.onStatusChanged((connected) => {
      setConnected(connected);
    });
    const unsubscribe = client.onMessage(opts.onMessage);
    client.connect();
    
    return () => {
      unsubscribe();
      client.disconnect();
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [client]);

  const send = useCallback((message) => {
    client.send(message);
  }, [client]);

  return {
    connected,
    send,
  };
};

export default useWebSocket;